const postQuicksight = {
  toastr: 'Usuario agregado',
  toastr1: ' fue agregado con éxito',
  toastrError: 'Respuesta ya registrada',
  toastrError1: 'Ingrese otro nombre'
};

export default postQuicksight;
